import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { PAGE_TITLES } from '../constants/routes';
import { getFilter } from '../services/filterPanel';
import '../styles/Header.css';
import { FaUserCircle } from 'react-icons/fa';
import AddSlotModal from '../Pages/addSlot/AddSlot';

const Header = ({ selectedLocation, onSelectLocation, onToggleSidebar }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [locations, setLocations] = useState([]);
  const [showAddSlotModal, setShowAddSlotModal] = useState(false);
  const dropdownRef = useRef(null);

  const getPageTitle = () => PAGE_TITLES[location.pathname] || PAGE_TITLES.DEFAULT;
  const pageTitle = getPageTitle();

  useEffect(() => {
    async function fetchCities() {
      try {
        const filters = await getFilter();
        const cityFilter = filters.find((f) => f.key === 'city');
        if (cityFilter && Array.isArray(cityFilter.values)) {
          setLocations(cityFilter.values);
          if (!selectedLocation && cityFilter.values.length > 0) {
            onSelectLocation(cityFilter.values[0]);
          }
        }
      } catch (error) {
        console.error('Failed to fetch cities for location dropdown:', error);
      }
    }
    fetchCities();
  }, [selectedLocation, onSelectLocation]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    if (dropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownOpen]);

  return (
    <header className="header">
      <div className="header-left">
        <button
          onClick={onToggleSidebar}
          className="toggle-button"
          aria-label="Toggle sidebar"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#333" strokeWidth="2">
            <line x1="4" y1="6" x2="20" y2="6" />
            <line x1="4" y1="12" x2="20" y2="12" />
            <line x1="4" y1="18" x2="20" y2="18" />
          </svg>
        </button>

        {pageTitle && <div className="page-title">{pageTitle}</div>}

        <div className="geolocation-label">Geolocation</div>

        <select
          value={selectedLocation}
          onChange={(e) => onSelectLocation(e.target.value)}
          className="location-select"
        >
          {locations.map((loc) => (
            <option key={loc} value={loc}>
              {loc.charAt(0).toUpperCase() + loc.slice(1)}
            </option>
          ))}
        </select>
      </div>

      <div className="header-right">
        {location.pathname === '/live' && (
          <button
            className="add-slot-button"
            onClick={() => setShowAddSlotModal(true)}
          >
            Add Slot
          </button>
        )}


        <div className="profile-wrapper" ref={dropdownRef}>
          <div className="profile-icon" onClick={() => setDropdownOpen((prev) => !prev)}>
            <FaUserCircle size={28} color="#333" />
          </div>

          {/* {dropdownOpen && (
            <div className="dropdown-menu">
              <div
                className="dropdown-item"
                onClick={() => {
                  setDropdownOpen(false);
                  navigate('/profile');
                }}
              >
                Profile
              </div>
            </div>
          )} */}
        </div>
      </div>

      <AddSlotModal
        open={showAddSlotModal}
        onClose={() => setShowAddSlotModal(false)}
        selectedLocation={selectedLocation}
      />
    </header>
  );
};

export default Header;
